import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css'; // Ensure this path is correct
const Footer = () => {
  return (
    <footer className="footer-container">
      {/* Quick Links */}
      <div className="quick-links">
        <Link to="/about-us" className="footer-link">
          About Us
        </Link>
        <Link to="/services" className="footer-link">
          Services
        </Link>
        <Link to="/careers" className="footer-link">
          Careers
        </Link>
        <Link to="/contact-us" className="footer-link">
          Contact Us
        </Link>
        <Link to="/privacy-policy" className="footer-link">
          Privacy Policy
        </Link>
      </div>

      {/* Social Media */}
      <div className="social-media">
        <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer" className="social-icon">
          <i className="fab fa-linkedin"></i>
        </a>
        <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer" className="social-icon">
          <i className="fab fa-twitter"></i>
        </a>
        <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" className="social-icon">
          <i className="fab fa-facebook"></i>
        </a>
      </div>

      {/* Copyright Section */}
      <div className="copyright">
        © {new Date().getFullYear()} Ensuresap. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;